import municipalitiesCentroids from "./municipalities_centroids.json";

const DEFAULT_ZOOM = 10;
const DEFAULT_FALLBACK_VIEW_STATE = {
  longitude: 23.7348324,
  latitude: 37.9755648,
  zoom: DEFAULT_ZOOM,
};

const toValidMunicipalityId = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const toValidMunicipalityIds = (values) => {
  if (!Array.isArray(values)) return [];
  return values
    .map(toValidMunicipalityId)
    .filter((value) => value !== null)
    .filter((value, index, allValues) => allValues.indexOf(value) === index);
};

const normalizeViewState = (viewState = {}) => ({
  longitude:
    typeof viewState.longitude === "number"
      ? viewState.longitude
      : DEFAULT_FALLBACK_VIEW_STATE.longitude,
  latitude:
    typeof viewState.latitude === "number"
      ? viewState.latitude
      : DEFAULT_FALLBACK_VIEW_STATE.latitude,
  zoom: typeof viewState.zoom === "number" ? viewState.zoom : DEFAULT_ZOOM,
});

export const getMunicipalityIdFromClientInfo = (clientInfo) => {
  return toValidMunicipalityId(clientInfo?.account?.municipalityId);
};

export const getNeighborMunicipalityIdsFromClientInfo = (clientInfo) => {
  return toValidMunicipalityIds(clientInfo?.account?.neighborMunicipalityIds);
};

export const getAllowedMunicipalityIdsFromClientInfo = (clientInfo) => {
  const municipalityId = getMunicipalityIdFromClientInfo(clientInfo);
  const neighborMunicipalityIds =
    getNeighborMunicipalityIdsFromClientInfo(clientInfo);

  return toValidMunicipalityIds([municipalityId, ...neighborMunicipalityIds]);
};

export const buildAllowedMunicipalitiesFilter = (allowedMunicipalityIds) => {
  const normalizedAllowedMunicipalityIds = toValidMunicipalityIds(
    allowedMunicipalityIds,
  );

  return [
    "in",
    ["to-number", ["get", "id"]],
    ["literal", normalizedAllowedMunicipalityIds],
  ];
};

export const buildOutsideAllowedMunicipalitiesFilter = (
  allowedMunicipalityIds,
) => {
  return ["!", buildAllowedMunicipalitiesFilter(allowedMunicipalityIds)];
};

export const getMunicipalityMapScope = ({
  clientInfo,
  fallbackViewState,
  mapKeyPrefix,
}) => {
  const municipalityId = getMunicipalityIdFromClientInfo(clientInfo);
  const allowedMunicipalityIds =
    getAllowedMunicipalityIdsFromClientInfo(clientInfo);
  const initialViewState = getMunicipalityMapInitialViewState({
    clientInfo,
    fallbackViewState,
  });

  return {
    municipalityId,
    allowedMunicipalityIds,
    initialViewState,
    mapInstanceKey: `${mapKeyPrefix}-${municipalityId ?? "fallback"}`,
  };
};

export const getMunicipalityMapInitialViewState = ({
  clientInfo,
  fallbackViewState,
}) => {
  const fallback = normalizeViewState(fallbackViewState);
  const municipalityId = getMunicipalityIdFromClientInfo(clientInfo);

  if (!municipalityId) {
    return fallback;
  }

  const municipalityCentroid = municipalitiesCentroids.find(
    (municipality) => municipality.id === municipalityId,
  );

  if (
    !municipalityCentroid ||
    typeof municipalityCentroid.centroid_lon !== "number" ||
    typeof municipalityCentroid.centroid_lat !== "number"
  ) {
    return fallback;
  }

  return {
    longitude: municipalityCentroid.centroid_lon,
    latitude: municipalityCentroid.centroid_lat,
    zoom: fallback.zoom,
  };
};
